import { validateDateRange } from "../../utils";

export const addPGValidation = (values) => {
  const errors = {};

  if (!values.name) errors.name = "Name is required";
  else if (values.name.length < 3) errors.name = "Name must be at least 3 characters";
  if (!values.depositAmount || isNaN(values.depositAmount)) errors.depositAmount = "Amount is required";
  else if (Number(values.depositAmount) <= 0) errors.depositAmount = "Amount must be greater than 0";
  if (!values.projectId || isNaN(values.projectId)) errors.projectId = "Please select a project";
  if (!values.fromAccountId || isNaN(values.fromAccountId)) errors.fromAccountId = "Please select an account";
  if (!values.depositDate) errors.depositDate = "Please select a deposit date";
  if (!values.endDate) errors.endDate = "Please select an end date";

  const pgDateErrors = validateDateRange({
    fieldName: "endDate",
    startDateKey: "depositDate",
    endDateKey: "endDate",
    startDate: values.depositDate,
    endDate: values.endDate,
    startErrorText: "Deposit date cannot be on or after End date",
    endErrorText: "End date e cannot be on or before Deposit date",
    allowSameDay: false,
  });

  if (pgDateErrors.depositDate) errors.depositDate = pgDateErrors.depositDate;
  if (pgDateErrors.endDate) errors.endDate = pgDateErrors.endDate;

  return errors;
};

export const addReturnValidation = (values, depositAmount) => {
  const errors = {};

  if (!values.releaseAmount || isNaN(values.releaseAmount)) errors.releaseAmount = "Amount is required";
  else if (Number(values.releaseAmount) < depositAmount)
    errors.releaseAmount = "Amount must be equal to or greater than " + depositAmount;
  if (!values.toAccountId || isNaN(values.toAccountId)) errors.toAccountId = "Please select an account to return fund";
  if (!values.releaseDate) errors.releaseDate = "Please select a release date";

  return errors;
};
